var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningDash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0176 5.51253V9.1792M10.0176 12.8459H10.0276M19.748 13.7627L11.748 0.929405C11.5736 0.647259 11.3206 0.412577 11.0149 0.249301C10.7092 0.0860258 10.3618 0 10.008 0C9.65421 0 9.30675 0.0860258 9.00107 0.249301C8.69539 0.412577 8.44243 0.647259 8.268 0.929405L0.267996 13.7627C0.0916782 14.0427 -0.00077593 14.3603 4.90526e-06 14.6835C0.00078574 15.0068 0.0947738 15.3241 0.272442 15.6032C0.450111 15.8824 0.705144 16.1136 1.01169 16.2733C1.31824 16.4331 1.6654 16.5156 2.018 16.5127H18.018C18.3689 16.5124 18.7135 16.4275 19.0173 16.2664C19.321 16.1054 19.5732 15.8739 19.7485 15.5953C19.9238 15.3166 20.016 15.0006 20.0159 14.6789C20.0159 14.3573 19.9234 14.0413 19.748 13.7627Z",
    stroke: "#D92D20",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningDash);
export default __webpack_public_path__ + "static/media/warningDash.1063027365e3b0423d7c71a5eea60d6a.svg";
export { ForwardRef as ReactComponent };